module.exports = __webpack_public_path__ + "static/media/schonfeld-footer.95de5608.svg";